import request from '@/utils/http';
const otpBaseUrl = '/api-antms/query';

// 查询承运商信息列表
export const getMonitorCarrier = params => {
    return request({
        url: `${otpBaseUrl}/dispatch/monitor/carrier`,
        method: 'get',
        params
    });
};

// 查询发车单信息列表
export const getMonitorDispatch = params => {
    return request({
        url: `${otpBaseUrl}/dispatch/monitor/dispatch`,
        method: 'get',
        params
    });
};
// 查询事件信息列表
export const getMonitorEvent = params => {
    return request({
        url: `${otpBaseUrl}/dispatch/monitor/event`,
        method: 'get',
        params
    });
};

// 使用发车单号模糊查询发车单信息(限制返回50条数据)
export const getDispatchNoFuzzy = params => {
    return request({
        url: `/api-antms/transport/dispatch/query/dispatchNo/fuzzy`,
        method: 'get',
        params
    });
};

// 查询货车当前地址信息接口
export const getDispatchNoLocationCurrent = params => {
    return request({
        url: `${otpBaseUrl}/dispatch/monitor/location/current`,
        method: 'get',
        params
    });
};

// 查询打点信息列表接口
export const getDispatchNoLocationPoint = params => {
    return request({
        url: `${otpBaseUrl}/dispatch/monitor/location/point`,
        method: 'get',
        params
    });
};

// 手工拉取中交兴路轨迹
export const getZjxlPointByDispatch = data => {
    return request({
        url: `${otpBaseUrl}/pullZjxlPointByDispatch`,
        method: 'post',
        data
    });
};